<div class="rto-warning-box" *ngIf="enabled">
        <mat-icon class="rto-warning-icon"  data-qa-id="rto-warning-message-icon">warning</mat-icon>
        <div class="rto-warning-text">{{warningMessage}}</div>
</div>
